import Swiper from "swiper/bundle";
import 'swiper/css/bundle';


export default {
    name: "product-gallery",
    init() {

        const fullScreenBtn = document.querySelector("#js_gallery_fullscreen");
        const gallery = document.querySelector(".product-gallery");

        if(fullScreenBtn && gallery){
            fullScreenBtn.addEventListener("click", e => {
                gallery.classList.toggle("fullscreen");
            });
        }
     

        if (document.querySelector('.swiper--product') && document.querySelector('.swiper--thumbnails')) {
            // init thumbnails
            const thumbnails = new Swiper(".swiper--thumbnails", {
                loop: true,
                spaceBetween: 10,
                slidesPerView: 5,
                // freeMode: true,
                watchSlidesProgress: true,
            });

            const swiper = new Swiper(".swiper--product", {
                loop: true,
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-nav-product__button-next",
                    prevEl: ".swiper-nav-product__button-prev",
                },
                thumbs: {
                    swiper: thumbnails,
                },
            });

        }
    },


};